/**
 * Hamburger menu toggle
 * Toggles .nav-open on both the header and the nav element.
 * Sets --header-height on :root so the fixed nav can offset itself correctly.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.site-header');
    const button = document.querySelector('.site-header__hamburger');
    const nav = document.getElementById('site-nav');

    if (!header || !button || !nav) return;

    function updateHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    function openNav() {
      header.classList.add('nav-open');
      nav.classList.add('nav-open');
      button.setAttribute('aria-expanded', 'true');
      nav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      header.classList.remove('nav-open');
      nav.classList.remove('nav-open');
      button.setAttribute('aria-expanded', 'false');
      nav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    button.addEventListener('click', function () {
      header.classList.contains('nav-open') ? closeNav() : openNav();
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
  });
})();
